import React from 'react';

function ReportTurnNavigator({
  t,
  totalTurns,
  effectiveTurnIndex,
  isViewingLatest,
  showStreamingTurn = false,
  onPrevTurn,
  onNextTurn,
  className = '',
}) {
  return (
    <div className={`turn-navigator-sticky${className ? ` ${className}` : ''}`}>
      <span className="turn-navigator-title">{t('report_turn_navigator_title')}</span>
      <div className="turn-navigator-controls">
        <button
          type="button"
          className="turn-nav-btn"
          onClick={onPrevTurn}
          disabled={totalTurns === 0 || effectiveTurnIndex <= 0 || showStreamingTurn}
          aria-label={t('report_prev_turn_aria')}
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span className="turn-indicator">
          {totalTurns > 0 ? (
            <>
              {t('report_turn_counter', { turn: effectiveTurnIndex + 1, total: totalTurns })}
              {isViewingLatest && <span className="turn-latest-badge">{t('report_turn_latest')}</span>}
            </>
          ) : (
            <span className="turn-waiting">{t('report_turn_waiting')}</span>
          )}
        </span>
        <button
          type="button"
          className="turn-nav-btn"
          onClick={onNextTurn}
          disabled={totalTurns === 0 || isViewingLatest}
          aria-label={t('report_next_turn_aria')}
        >
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default ReportTurnNavigator;
